function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import useCurrentUser from "@sprout/client-graphql/dist/useCurrentUser";
import generateOptimisticId from "@sprout/client-lib/dist/generateOptimisticId";
import generateRandomKey from "@sprout/client-lib/dist/generateRandomKey";
import { useCallback } from "react";
import { useApolloClient } from "@apollo/client";
import { useParams } from "react-router-dom";
import { ItemType, TopicPage_SectionFragmentDoc, TopicPage_Views_TopicDocument, useTopicPage_CreateDividerMutation } from "sprout-graphql";
import update from "immutability-helper";
import { optimisticPost } from "@sprout/client-components/dist/Post";
function getNodes({ nodes , item , afterItemId  }) {
    if (nodes.length === 0) return [
        item
    ];
    return nodes.reduce((acc, currentValue)=>{
        if (currentValue.id === item.id) return acc;
        // first
        if (acc.length === 0 && afterItemId === null) return [
            item,
            ...acc,
            currentValue
        ];
        // after
        if (currentValue.id === afterItemId) return [
            ...acc,
            currentValue,
            item
        ];
        // continue
        return [
            ...acc,
            currentValue
        ];
    }, []);
}
export default function useTopicPageCreateDivider() {
    const client = useApolloClient();
    const [createDivider] = useTopicPage_CreateDividerMutation();
    const currentUser = useCurrentUser();
    const params = useParams();
    const topicId = Number(params.topicId);
    return useCallback(function() {
        var _ref = _asyncToGenerator(function*(args) {
            var ref1;
            const pageCache = client.readQuery({
                query: TopicPage_Views_TopicDocument,
                variables: {
                    topicId
                }
            });
            // const topic = pageCache?.topic;
            let section;
            if (args.context === "page_section") {
                const fragmentCache = client.readFragment({
                    id: args.topicNodeId,
                    fragment: TopicPage_SectionFragmentDoc,
                    fragmentName: "TopicPage_Section"
                });
                section = fragmentCache || undefined;
            }
            if (!pageCache || !pageCache.topic || !currentUser) return undefined;
            const { variables  } = args;
            const { display , title , afterItemId , parentTopicId  } = variables;
            const { topic  } = pageCache;
            const { rootTopicOrSelf  } = topic;
            return createDivider({
                variables,
                optimisticResponse: {
                    createItem: {
                        item: _objectSpread({}, optimisticPost, {
                            nodeId: generateRandomKey(),
                            id: generateOptimisticId(),
                            type: ItemType.Divider,
                            rootTopicOrSelf: rootTopicOrSelf ? _objectSpread({}, rootTopicOrSelf, {
                                special: null
                            }) : null,
                            parentTopic: _objectSpread({}, section || topic, {
                                isRootTopic: section ? false : topic.isRootTopic,
                                special: null,
                                parentTopicId: section ? topic.id : ((ref1 = topic.parentTopic) === null || ref1 === void 0 ? void 0 : ref1.id) || null
                            }),
                            parentTopicId,
                            owner: currentUser,
                            position: Number.MAX_SAFE_INTEGER,
                            title,
                            display
                        }),
                        __typename: "CreateItemPayload"
                    }
                },
                update (proxy, { data  }) {
                    var ref;
                    const item = data === null || data === void 0 ? void 0 : (ref = data.createItem) === null || ref === void 0 ? void 0 : ref.item;
                    if (item) {
                        if (args.context === "page") proxy.writeQuery({
                            query: TopicPage_Views_TopicDocument,
                            variables: {
                                topicId
                            },
                            data: update(pageCache, {
                                topic: {
                                    posts: {
                                        nodes: {
                                            $apply (nodes) {
                                                return getNodes({
                                                    nodes,
                                                    item,
                                                    afterItemId
                                                });
                                            }
                                        }
                                    }
                                }
                            })
                        });
                        else proxy.writeFragment({
                            id: args.topicNodeId,
                            fragment: TopicPage_SectionFragmentDoc,
                            fragmentName: "TopicPage_Section",
                            data: update(section, {
                                posts: {
                                    totalCount: {
                                        $apply: (totalCount)=>totalCount + 1
                                    },
                                    nodes: {
                                        $apply (nodes) {
                                            return getNodes({
                                                nodes,
                                                item,
                                                afterItemId
                                            });
                                        }
                                    }
                                }
                            })
                        });
                    }
                }
            });
        });
        return function(args) {
            return _ref.apply(this, arguments);
        };
    }(), [
        client,
        createDivider,
        currentUser,
        topicId
    ]);
};
